import { render, staticRenderFns } from "./UnidentifiedStockRequests.vue?vue&type=template&id=34986ec4"
import script from "./UnidentifiedStockRequests.vue?vue&type=script&lang=js"
export * from "./UnidentifiedStockRequests.vue?vue&type=script&lang=js"
import style0 from "./UnidentifiedStockRequests.vue?vue&type=style&index=0&id=34986ec4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports